<template>
     <v-card>
        <v-layout>
            <v-card-title class="headline">
                <strong class="headline deep-purple--text">Criar evento</strong> 
            </v-card-title>
        </v-layout>
        <v-divider class="deep-purple"/>
        <v-layout row wrap class="mx-4 mt-3">        
            <v-flex xs12 md6 class="pr-1">
                <SelectCreditors :multiple="true" @selectedCreditors="creditors_ids = $event" />
            </v-flex>
            <v-flex xs12 md6 class="pl-1">
                <v-menu offset-y full-width> 
                    <v-text-field slot="activator" label="Dia" :value="event.event_time | formatDateUTC" box readonly/> 
                    <v-date-picker v-model="event.event_time" locale="br" />  
                </v-menu>  
            </v-flex>
            <v-flex sm12>
                <v-text-field class="mx-1" type="text" label="Título" box v-model="event.title" hint="máximo: 100 caracteres"/>                
            </v-flex>  
            <v-flex sm12>
                <v-textarea class="mx-1" type="text" label="Descrição" box v-model="event.description" hint="máximo: 2000 caracteres"/>                
            </v-flex>        
        </v-layout>
        <v-divider class="deep-purple"/>
        <v-card-actions class="py-2">
            <v-btn flat color="primary" @click="fechar_modal">Cancelar</v-btn>  
            <v-spacer></v-spacer>
            <v-btn color="deep-purple white--text" @click="salvar" :disabled="(esperar || creditors_ids.length == 0)">Salvar</v-btn>     
        </v-card-actions>
    </v-card>   
</template>

<script>
import SelectCreditors from "@/components/creditor/SelectCreditors";
export default {
    components:{
        SelectCreditors
    },
    props:['esperar'],
    data(){
        return{
            event:{
               creditors:[],
               event_time:'',
               title:'',
               description:''
           },
           creditors_ids:[]
        }
    },
    methods:{
        estado_inicial(){
            this.event = {
                event_time:'',
                title:'',
                description:'',
                creditors: []
           }
        },
        fechar_modal(){
            this.$emit('fechar')
            this.estado_inicial()
        },
        salvar(){
            this.event.event_time = this.event.event_time + 'T00:00:00'
            this.event.creditors = this.creditors_ids.map((c_id)=>{return{'id':c_id}})
            
            this.$emit('salvar', this.event)
            this.estado_inicial()
        }
    }
}
</script>